import React from 'react';

const FeatureSection = () => {
  const features = [
    {
      title: "精准匹配度分析",
      description: "深度分析简历内容与目标岗位要求的匹配程度，提供量化评分",
      icon: "🎯"
    },
    {
      title: "多格式简历支持",
      description: "支持PDF、DOCX等多种简历格式，自动提取和解析关键信息",
      icon: "📄"
    },
    {
      title: "专业评估报告",
      description: "生成包含匹配度、优势分析、改进建议的详细评估报告",
      icon: "📊"
    },
    {
      title: "职位库管理",
      description: "创建和管理心仪岗位库，建立标准化的职位评估体系",
      icon: "💼"
    },
    {
      title: "评估历史追踪",
      description: "保存所有评估记录，便于追踪和比较不同候选人的匹配表现",
      icon: "📈"
    },
    {
      title: "高效招聘工具",
      description: "简化简历筛选流程，大幅提升招聘效率和准确性",
      icon: "⚡"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            核心功能
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            专业的简历与心仪岗位匹配度评估解决方案
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gray-50 p-8 rounded-xl hover:shadow-lg transition-shadow"
            >
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;